import DcbService from "@/services/dcbService";
import SafaricomService from "@/services/safaricomService";

export const msisdnLookup = async (options = {}) => {
    const urlParams = new URLSearchParams(window.location.search);
    const eMsisdn = urlParams.get('e-msisdn')

    let decryptedMsisdn;
    if (eMsisdn) {
        const response = await DcbService.decryptUserMsisdn(eMsisdn);
        if (response.rawMsisdn) decryptedMsisdn = response.rawMsisdn;
    }

    return await SafaricomService.getMSISDN(decryptedMsisdn, options);
};